/* El Matador Knives — static site behaviour */
(function () {
  "use strict";

  var CART_KEY = "em_cart_v1";

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function readCart() {
    try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch (e) { return []; }
  }
  function writeCart(items) {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    renderCartCount();
  }

  /* ---------- sticky / shrinking header ---------- */
  var header = document.querySelector("header");
  if (header) {
    var shrink = ["py-3", "shadow-sm"];
    var normal = ["py-5"];
    var apply = function () {
      var scrolled = window.scrollY > 50;
      shrink.forEach(function (c) { header.classList.toggle(c, scrolled); });
      normal.forEach(function (c) { header.classList.toggle(c, !scrolled); });
    };
    window.addEventListener("scroll", apply, { passive: true });
    apply();
  }

  /* ---------- mobile menu ---------- */
  var menuBtn = $('[data-em="menu-toggle"]');
  var mobileMenu = $('[data-em="mobile-menu"]');
  if (menuBtn && mobileMenu) {
    var open = false;
    var setMenu = function (state) {
      open = state;
      mobileMenu.classList.toggle("max-h-[400px]", open);
      mobileMenu.classList.toggle("opacity-100", open);
      mobileMenu.classList.toggle("max-h-0", !open);
      mobileMenu.classList.toggle("opacity-0", !open);
      menuBtn.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    };
    setMenu(false);
    menuBtn.addEventListener("click", function () { setMenu(!open); });
    $all("a", mobileMenu).forEach(function (a) {
      a.addEventListener("click", function () { setMenu(false); });
    });
  }

  /* ---------- product gallery ---------- */
  var mainImg = $('[data-em="gallery-main"]');
  var thumbs = $all('[data-em="gallery-thumb"]');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-src");
        if (src) mainImg.setAttribute("src", src);
        thumbs.forEach(function (t) {
          t.classList.toggle("border-secondary", t === btn);
          t.classList.toggle("border-transparent", t !== btn);
        });
      });
    });
  }

  /* ---------- quantity stepper ---------- */
  var qtyValue = $('[data-em="qty-value"]');
  function currentQty() {
    var n = qtyValue ? parseInt(qtyValue.textContent.trim(), 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }
  if (qtyValue) {
    var minus = $('[data-em="qty-minus"]');
    var plus = $('[data-em="qty-plus"]');
    if (minus) minus.addEventListener("click", function () {
      qtyValue.textContent = String(Math.max(1, currentQty() - 1));
    });
    if (plus) plus.addEventListener("click", function () {
      qtyValue.textContent = String(currentQty() + 1);
    });
  }

  /* ---------- cart ---------- */
  function renderCartCount() {
    var count = readCart().reduce(function (s, i) { return s + i.qty; }, 0);
    $all('[data-em="cart"]').forEach(function (btn) {
      var badge = btn.querySelector(".em-cart-badge");
      if (count === 0) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "em-cart-badge absolute -top-1 -right-1 bg-primary text-primary-foreground text-[10px] font-semibold rounded-full h-5 min-w-5 px-1 flex items-center justify-center";
        btn.appendChild(badge);
      }
      badge.textContent = String(count);
    });
  }

  function toast(message) {
    var el = document.createElement("div");
    el.textContent = message;
    el.setAttribute("role", "status");
    el.className = "fixed bottom-6 right-6 z-[100] rounded-md bg-card text-foreground border border-border px-5 py-3 shadow-lg text-sm font-body";
    el.style.opacity = "0";
    el.style.transition = "opacity 300ms ease-out";
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = "1"; });
    setTimeout(function () {
      el.style.opacity = "0";
      setTimeout(function () { el.remove(); }, 350);
    }, 2200);
  }

  /* Live Shopify add-to-cart */
  function emCurrentQty(){ var el = document.querySelector('[data-em="qty-value"]'); if(!el) return 1; var n=parseInt(el.textContent.trim(),10); return (isNaN(n)||n<1)?1:n; }
  document.addEventListener("click", function(e){
    var btn = e.target.closest && e.target.closest('[data-em-add]');
    if(!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-em-add');
    if(!id) return;
    var qty = btn.hasAttribute('data-em-usentqty') ? emCurrentQty() : (document.querySelector('[data-em="qty-value"]') && btn.closest('[data-em-product]') ? emCurrentQty() : 1);
    btn.disabled = true;
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id: parseInt(id,10), quantity: qty }] }) })
      .then(function(r){ return r.json(); })
      .then(function(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; el.style.display = cart.item_count>0?'':'none'; });
        toast("Added to cart");
        var prev = btn.textContent; btn.textContent = "Added \u2713";
        setTimeout(function(){ btn.textContent = prev; btn.disabled = false; }, 1400);
      })
      .catch(function(){ btn.disabled=false; });
  });

  /* ---------- collection filter chips ---------- */
  $all('[data-em="chip"]').forEach(function (btn) {
    var href = btn.getAttribute("data-href");
    if (!href) return;
    btn.style.cursor = "pointer";
    btn.addEventListener("click", function () { window.location.href = href; });
  });

  /* ---------- scroll reveal animations ---------- */
  var revealTargets = $all(".animate-fade-up, .animate-fade-in, .animate-scale-in");
  if ("IntersectionObserver" in window && revealTargets.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = "running";
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealTargets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- smooth anchor scrolling ---------- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var hash = a.getAttribute("href").split("#")[1];
    if (!hash) return;
    var target = document.getElementById(hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  /* ---------- forms: native validation + success state ---------- */
  $all("form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      toast("Thank you — we'll be in touch shortly.");
      form.reset();
    });
  });
})();
